import React from 'react';
import { ShieldCheck, HardDrive, Lock } from 'lucide-react';

const LocalFirst = () => {
  return (
    <section id="local-first" className="my-20">
      <div className="bg-gradient-to-br from-apple-800/60 to-apple-900/60 backdrop-blur-md rounded-3xl border border-apple-700/40 p-8 sm:p-12 relative overflow-hidden">
        <div className="absolute -left-32 -top-32 w-72 h-72 rounded-full bg-sortio-primary/10 blur-[100px]" />
        <div className="absolute -right-32 -bottom-32 w-72 h-72 rounded-full bg-sortio-secondary/10 blur-[100px]" />

        <div className="relative z-10">
          <div className="flex items-center mb-6">
            <div className="w-12 h-12 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-4">
              <ShieldCheck className="text-sortio-primary" size={22} />
            </div>
            <span className="text-xs font-medium uppercase tracking-wider text-sortio-primary">
              Private by default
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-semibold mb-6 tracking-tight text-apple-50 max-w-3xl">
            Keep your photos and tax returns on your Mac with local mode
          </h2>

          <div className="max-w-3xl space-y-5 text-apple-200 leading-relaxed">
            <p>
              Sortio runs on your Mac, and the file itself always stays on your hard drive. To
              figure out the right folder, Sortio reads the text inside a PDF or document (for
              photos it uses the filename, date, and metadata); the read happens locally, and the
              inference runs against a model you choose. In Offline mode
              (a local LLM like Ollama) or with your own API key (BYOK), the text it reads never
              leaves your machine: we never see your kid's birth certificate, your medical bills,
              or your wedding photos, because we just don't have them.
            </p>
            <p>
              By default Sortio uses our cloud (OpenAI) to plan the sort, which sends filenames and
              folder paths; file contents are sent only if you turn on a content-based feature like
              renaming or matching by content. Want total isolation? Switch to a local LLM running
              on your own machine and nothing leaves your Mac. Either way, the file itself stays on
              your hard drive.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
            <div className="bg-apple-800/40 rounded-2xl border border-apple-700/50 p-6">
              <div className="flex items-center mb-3">
                <HardDrive className="text-sortio-primary mr-2" size={18} />
                <h3 className="text-base font-medium text-apple-50">Lives on your hard drive</h3>
              </div>
              <p className="text-sm text-apple-200 leading-relaxed">
                Files stay where they are. Sortio just renames and reorganizes them in place.
                Works with iCloud Photos, Google Drive, Dropbox, or just a plain Pictures folder.
              </p>
            </div>

            <div className="bg-apple-800/40 rounded-2xl border border-apple-700/50 p-6">
              <div className="flex items-center mb-3">
                <Lock className="text-sortio-primary mr-2" size={18} />
                <h3 className="text-base font-medium text-apple-50">Undo any time</h3>
              </div>
              <p className="text-sm text-apple-200 leading-relaxed">
                Every sort is previewed before it runs and reversible after. If you don't like
                where something landed, one click puts it back.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalFirst;
